<template>
  <div class="section">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/services">Services</router-link>
      <router-link :to="`/services/100`"><Icon icon="computer" />Antrag auf Ausbildungsförderung</router-link>
      <router-link to="/services/100/section-2">Schulischer & beruflicher Werdegang</router-link>
    </Breadcrumb>
    <div class="section__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/services/100" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="education" color="detailed" class="hide-mobile"/>
          <Headline subline="Abschnitt 2" headline="Schulischer & beruflicher Werdegang" />
        </div>
        <div class="headline-link__right hide-mobile">
          <div>
            <h3><b>01</b> / 02</h3>
            <div class="progress" title="Fortschritt">
              <div class="bar" style="width: 50%;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs top-xs">
        <div class="section__content__left col-xs-12 col-md-8">

<!-- Schulischer Werdegang -->
          <h3 class="margin-bottom--20 margin-top--60">1. Schulischer Werdegang</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <transition-group name="showcase" mode="out-in">
            <div v-for="(school, index) in schools" :key="school" class="block">
              <div v-show="index > 0" class="delete" title="Block entfernen" @click="removeSchool(index)"><Icon icon="close" /></div>
              <div class="row">
                <div class="col-xs-12 label-hint">
                  <h6>{{ index+1 }}. Schule / Ausbildungsstätte</h6>
                  <div class="hint">
                    <Icon icon="hint" />
                    <div class="hint__tooltip">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputText name="iban" type="text" :hint="true" placeholder="z.B. Theresa-Gerhardinger Realschule">
                    Name
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputSelect name="schoolstyle" :values="['Realschule', 'Gymnasium', 'Fachoberschule', 'Gesamtschule', 'Waldorfschule']" :hint="true">
                    Schulart
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </InputSelect>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputAutocomplete name="place" :list="['Augsburg', 'Freiburg', 'Ravensburg', 'Berlin', 'Frankfurt', 'Hamburg', 'Köln', 'Dortmund']" :hint="true">
                    Ort
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputAutocomplete>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputSelect name="schoolstyle" :values="['Mittlere Reife', 'Abitur', 'Fachhochschulreife']" :hint="true">
                    Erreichter Abschluss
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </InputSelect>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputText name="from" type="date" :hint="true">
                    Von
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputText name="to" type="date" :hint="true">
                    Bis
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
              </div>
            </div>
            </transition-group>

            <div class="row margin-top--30">
              <div class="col-xs-12">
                <p class="add" @click="newSchool">+ Weitere Ausbildungsstätte hinzufügen</p>
              </div>
            </div>

          </div>

<!-- Beruflicher Werdegang -->
          <h3 class="margin-bottom--20 margin-top--60">2. Beruflicher Werdegang</h3>
          <div class="greenline margin-bottom--30"></div>
          <div class="field">
            <transition-group name="showcase" mode="out-in">
            <div v-for="(work, index) in works" :key="work" class="block">
              <div v-show="index > 0" class="delete" title="Block entfernen" @click="removeWork(index)"><Icon icon="close" /></div>
              <div class="row">
                <div class="col-xs-12 label-hint">
                  <h6>{{ index+1 }}. Arbeitgeber</h6>
                  <div class="hint">
                    <Icon icon="hint" />
                    <div class="hint__tooltip">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputText name="name" type="text" :hint="true">
                    Name des Arbeitgebers/Leistungsträgers
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputSelect name="workstyle" :values="['Ausbildung', 'Praktikum', 'Werkstudent', 'Angestellter', 'Freiberufler']" :hint="true">
                    Art der Tätigkeit
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </InputSelect>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputAutocomplete name="place" :list="['Augsburg', 'Freiburg', 'Ravensburg', 'Berlin', 'Köln', 'Frankfurt', 'Hamburg', 'Regensburg']" :hint="true">
                    Ort
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputAutocomplete>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputText name="salary" type="number" :hint="true" placeholder="2000">
                    Bruttonlohn/Höhe der Leistung monatlich (€)
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </InputText>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-6">
                  <InputText name="from" type="date" :hint="true">
                    Von
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
                <div class="col-xs-12 col-md-6">
                  <InputText name="to" type="date" :hint="true">
                    Bis
                    <div slot="hint">
                      <h6>Hinweis</h6>
                      <p class="margin-bottom--20">Die Angabe Ihrer Steueridentifikationsnummer ist für das gesetzlich vorgeschriebene Datenübermittlungsverfahren nach § 10 Abs. 4b EStG zwingend erforderlich. </p>
                      <h6>Warum ist das wichtig?</h6>
                      <p>Anhand dieser Angaben können wir überprüfen in wie weit Sie für die Ausbildungsförderung in Frage kommen und wie hoch ihre monatlicher Zuschuss ist.</p>
                    </div>
                  </inputText>
                </div>
              </div>
            </div>
            </transition-group>

            <div class="row margin-top--30">
              <div class="col-xs-12">
                <p class="add" @click="newWork">+ Weiteren Arbeitgeber hinzufügen</p>
              </div>
            </div>

          </div>

          
        </div>
        
        <Modal v-if="showFileModal" @closeModal="toggleFileModal" :outside="true">
          <Card padding="35px" class="modal-new">
            <Headline subline="Datenfeld bearbeiten" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>
        <Modal v-if="showDocModal" @closeModal="toggleDocModal" :outside="true">
          <Card padding="0px" class="modal-file">
            <div class="content">
              <div class="content__headline">
                <Icon icon="docBox" color="detailed" />
                <Headline subline="Bürgerkonto" headline="Ihre Dokumentenbox"/>
              </div>
              <div v-if="activeUser && folders && userDocs" class="docbox__bottom">
                <div v-for="folder in folders" :key="folder.id" @click="toggleDocModal" class="doc">
                  <Icon icon="folder" />
                  <p>{{ folder.name }}</p>
                  <div class="folder-size hide-mobile"><Icon icon="file"/>{{ folder.docs.length }} Dateien</div>
                </div>
                <div v-for="(doc, index) in userDocs" v-show="index < 5" :key="doc.id" @click="toggleDocModal" class="doc">
                  <Icon icon="file" />
                  <p :class="{'new' : !doc.seen}">{{ doc.name }}</p>
                  <span>Auswählen</span>
                </div>
              </div>
              <div v-else class="docbox--empty">
                <p class="margin-top--20 margin-bottom--20">Melden Sie sich bitte in Ihrem Bürgerkonto an, um Ihre Dokumente einsehen zu können.</p>
              </div>
            </div>
            <div class="autofill-hint">
              <img src="../../assets/images/status/hint.svg">
              <p>Dokumente aus Ihrer Bürgerkonto-Dokumentenbox können nur Sie einsehen. Keine Einrichtung der öffentlichen Verwaltung hat ohne Ihre Zustimmung Zugriff auf Ihre Dateien.</p>
            </div>  
          </Card>        
        </Modal>

        <!-- Sidebar -->
        <div class="section__content__sidebar col-xs-12 col-md-3">
          <div class="nav-element"
            @click="activeField = 1"
            :class="{'selected' : activeField == 1}"
            >
            <p>01. Schulischer Werdegang</p>
            <div class="status"></div>
          </div>
          <div class="nav-element"
            @click="activeField = 2"
            :class="{'selected' : activeField == 2}"
            >
            <p>2. Beruflicher Werdegang</p>
            <div class="status"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="teaser">
      <div class="wrapper">
        <div class="row between-xs">
          <div class="col-xs-12 col-md-8">
            <div class="row">
              <div class="col-xs-12 col-md-6">
                <router-link to="/services/100/section-1">
                  <Button type="secondary" text="Vorheriger Abschnitt"/>
                </router-link>
              </div>
              <div class="col-xs-12 col-md-6">
                <Button type="secondary" text="Eingaben prüfen"/>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-3">
            <router-link to="/services/100/section-3">
              <Button type="primary" text="Weiter zu Abschnitt 3"/>
            </router-link>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';
import InputSelect from '../../components/formElements/InputSelect/InputSelect';
import InputAutocomplete from '../../components/formElements/InputAutocomplete/InputAutocomplete';


export default {
  name: 'Section1',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
    InputAutocomplete,
    InputSelect,
  },
  data() {
    return {
      showModal: false,
      showFileModal: false,
      showDocModal: false,
      activeField: 1,
      toggleAll: false,
      time: '',
      home: false,
      insurance: false,
      baby: false,
      schools: ['school1'],
      works: ['work1'],
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      folders: 'documents/getAllFolders',
      userDocs: 'documents/getAllDocs',
    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleFileModal() {
      this.showFileModal = !this.showFileModal;
    },
    toggleDocModal() {
      this.showDocModal = !this.showDocModal;
    },
    newSchool() {
      this.schools.push('school');
    },
    removeSchool(i) {
      this.schools.splice(i, 1);
    },
    newWork() {
      this.works.push('work');
    },
    removeWork(i) {
      this.works.splice(i, 1);
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Section.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Section/Section2.vue